<template>
  <div class="live-top-tag-list">
    <span v-if="hasLive" class="live-tag">
      <div class="dot" :class="{ animate: animate }"></div>
      LIVE
    </span>
  </div>
</template>
<script setup lang="ts">
  import { computed, defineProps } from 'vue'

  const props = defineProps({
    topTagList: {
      type: Array,
      default: () => [],
    },
    animate: {
      type: Boolean,
      default: false,
    },
  })

  const hasLive = computed(() => {
    return props.topTagList.includes('live')
  })
</script>
<style scoped lang="scss">
  .live-top-tag-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .live-tag {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    background-color: #d82c35;
    border-radius: 4px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 4px;
  }
  @keyframes blink {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .dot {
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: #fff;
    margin-right: 4px;
  }
  .dot.animate {
    animation: blink 2000ms linear infinite;
  }
</style>
